import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from './styles';
import PrimaryButton from '../../../components/Buttons/PrimaryButton';
import { CardPlusIcon } from '../../../assets/svg/SVGComponents';

const NoPostProject: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <img
        src="https://fuzzyplaydev.s3.us-east-2.amazonaws.com/illustration+clean/no-project-posted-2.png"
        alt="no-posted-project"
      />
      <p>
        Você ainda não possui projetos publicados. Que tal compartilhar suas
        ideias com o mundo?
        <br /> Sinta-se à vontade para publicar e inspirar nossa comunidade!
      </p>

      <PrimaryButton type="button" onClick={() => navigate('/create/post')}>
        <CardPlusIcon
          width="1.6rem"
          stroke="#FFffff"
          strokeWidth={2}
          fill="none"
        />
        <p>Publicar projeto</p>
      </PrimaryButton>
    </Container>
  );
};

export default NoPostProject;
